import React, {useMemo} from 'react';
import {Button, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";
import ShieldTwoToneIcon from "@mui/icons-material/ShieldTwoTone";
import ActionCard from "./actions/ActionCard";
import MessaggiCard from "./messaggi/MessaggiCard";
import {EventiPaper} from "./v2/eventi/EventiPaper";
import {ProfiloPaper} from "./v2/profilo/ProfiloPaper";
import {HomeStyle} from "../../../styles/pages/home/HomeStyle";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {actions} from "../../../utils/dictionaries/Actions";
import {useHistory} from "react-router-dom";
import AppPage from "../../widgets/layout/AppPage";

export const Home = () => {
	const classes = HomeStyle();
	const history = useHistory();
	const account = getAccountInfo() || {};

	const enabledActions = useMemo(() => Object.values(actions)
		.filter((action) => account.roles?.some((role) => action.roles.some((actionRole) => actionRole === role))), [account.roles]);

	return (
		<AppPage title="Dashboard" mainClassName={classes.page} containerClassName={classes.container}>
				<section className={classes.hero}>
					<div className={classes.heroMain}>
						<div className={classes.heroContent}>
							<Typography className={classes.eyebrow}>Atlantis workspace</Typography>
							<Typography className={classes.heroTitle} variant="h2">
								Ciao {account.alias || account.username || "Atlantis"}, bentornato.
							</Typography>
							<Typography className={classes.heroSubtitle}>
								Una dashboard piu pulita per arrivare subito agli strumenti importanti: richieste,
								anagrafiche, report, moduli e impostazioni.
							</Typography>
							<div className={classes.heroActions}>
								<Button className={classes.heroButton} variant="contained" disableElevation
								        onClick={() => history.push("/gestione/tickets")}>
									Apri richieste
								</Button>
								<Button className={classes.heroButtonGhost} variant="outlined"
								        onClick={() => history.push("/gestione/azioni")}>
									Tutte le azioni
								</Button>
							</div>
						</div>
					</div>

					<div className={classes.metricsPanel}>
						<div className={classes.metric} style={{"--metric-color": "#4285F4", "--metric-color-2": "#00A8E8"}}>
							<div className={classes.metricIcon}><AppsRoundedIcon/></div>
							<div>
								<Typography className={classes.metricLabel}>Azioni abilitate</Typography>
								<Typography className={classes.metricValue}>{enabledActions.length}</Typography>
							</div>
						</div>
						<div className={classes.metric} style={{"--metric-color": "#34A853", "--metric-color-2": "#00A8A8"}}>
							<div className={classes.metricIcon}><ShieldTwoToneIcon/></div>
							<div>
								<Typography className={classes.metricLabel}>Ruoli attivi</Typography>
								<Typography className={classes.metricValue}>{account.roles?.length || 0}</Typography>
							</div>
						</div>
						<div className={classes.metric} style={{"--metric-color": "#EA4335", "--metric-color-2": "#FBBC05"}}>
							<div className={classes.metricIcon}><AssignmentTwoToneIcon/></div>
							<div>
								<Typography className={classes.metricLabel}>Area rapida</Typography>
								<Typography className={classes.metricValue}>Ticket</Typography>
							</div>
						</div>
					</div>
				</section>

				<Grid container spacing={2}>
					<Grid size={{xs: 12, lg: 12}}>
						<ActionCard/>
					</Grid>
					<Grid size={{xs: 12, lg: 4}}>
						<ProfiloPaper/>
					</Grid>
					<Grid size={{xs: 12, md: 6}}>
						<MessaggiCard/>
					</Grid>
					<Grid size={{xs: 12, md: 6}}>
						<EventiPaper/>
					</Grid>
				</Grid>
		</AppPage>
	);
};
